import React, {Component} from "react";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import PageBack from "../components/buttons/page-back";
import {preloaderHide, preloaderShow} from "../../libs/redux/actions/preloader";
import {api, apis, rd, sendGet} from "../../vars/rd";
import DaoChannel from "../../modules/dao/channel";
import ChannelItem from "../components/elements/channel.item";

class MypageChannel extends Component {
    constructor(props) {
        super(props);
        this.state = {
            channels: [],
            page_count: 0,
            total: 0
        };
    }

    /**
     * 페이지 마운트
     */
    componentDidMount() {
        this.mounted = true;

        (async () => {
            await this.channelData();
        })();
    }

    /**
     * 페이지 언마운트
     */
    componentWillUnmount() {
        this.mounted = false;
    }

    get dispatch() {
        return this.props.hasOwnProperty("dispatch") ? this.props.dispatch : () => {};
    }

    async channelData() {
        try {
            this.dispatch(preloaderShow());
            const url = api(apis.channel_favorite_list, {
                serviceid: rd.user.serviceid,
                groupid: rd.user.groupid
            });
            const json = await sendGet(url);
            if(this.mounted) {
                const page_count = json.page_count;
                const total = json.total;

                this.dispatch(preloaderHide());
                const channels = [];
                if (json.items.length) {
                    for (let i = 0; i < json.items.length; i++) {
                        channels.push(new DaoChannel(json.items[i]));
                    }
                }

                this.setState({channels: [...this.state.channels, ...channels], page_count, total}, () => {
                    this.is_loading = false;
                });
            }
        } catch (e) {
        }
    }


    render() {
        return (
            <div className="mychannel">
                <h2>
                    <PageBack />
                    내 채널
                </h2>
                <div className="mychannel-wrap">
                    {
                        this.state.channels && this.state.channels.map(
                            (channel, channel_index) => {
                                return <ChannelItem key={channel_index} data={channel}/>
                            }
                        )
                    }
                </div>
            </div>
        );
    }
}

export default connect()(withRouter(MypageChannel));


// WEBPACK FOOTER //
// ./src/pages/mypage/channel.jsx